import { useEffect, useState } from 'react';
import { Button, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';
import { Box, Center, Column } from '~/commonComponents';

interface IInputReferralLinkProps {
  shortLink?: string;
  isLinkingSuccess: boolean;
  isLoading: boolean;
  onSubmit: (referralLink: string) => void;
  errorMessage?: string;
}

export const InputReferralLink = ({
  shortLink,
  isLinkingSuccess,
  isLoading,
  onSubmit,
  errorMessage,
}: IInputReferralLinkProps) => {
  const [referralLink, setReferralLink] = useState('');

  useEffect(() => {
    if (shortLink) {
      setReferralLink(shortLink);
    }
  }, [shortLink]);

  const handleSubmit = () => {
    onSubmit(referralLink);
  };

  return (
    <Column marginTop={32}>
      {isLinkingSuccess && (
        <Center gap={12}>
          <Typography as="span" size="body_large" bold color={colors.primary[500]}>
            Referral Link Submitted!
          </Typography>
          <Typography as="span" color={colors.neutral[500]}>
            Your friend’s referral link has been submitted successfully!
          </Typography>
        </Center>
      )}
      {!isLinkingSuccess && (
        <>
          <Typography
            as="span"
            bold
            color={colors.neutral[600]}
            size="body_large"
            style={{ marginBottom: 10, marginLeft: 2 }}
          >
            Enter and Submit Their Referral
          </Typography>
          <Column>
            <input
              className="input-field"
              style={{ margin: 0, width: '380px', borderRadius: 10 }}
              type="text"
              value={referralLink}
              onChange={(e) => setReferralLink(e.target.value)}
              placeholder="Enter Referral Link"
            />
            <Box height={16} marginTop={4} marginBottom={32}>
              {errorMessage && (
                <Typography
                  as="span"
                  color={colors.error[500]}
                  size="caption"
                  style={{ marginLeft: 2 }}
                >
                  {errorMessage}
                </Typography>
              )}
            </Box>
          </Column>
          <Center>
            <Button size="lg" onClick={handleSubmit} isLoading={isLoading} disabled={isLoading}>
              Submit Referral Link
            </Button>
          </Center>
        </>
      )}
    </Column>
  );
};
